export const VITAL_SIGN_TYPES = {
  temperature: 'temperature',
  weight: 'weight',
  'blood-pressure': 'blood-pressure',
  'heart-rate': 'heart-rate',
} as const;

export type VitalSignType =
  (typeof VITAL_SIGN_TYPES)[keyof typeof VITAL_SIGN_TYPES];

export const VITAL_SIGNS_TAB_OPTIONS = {
  recent: 'recent',
  custom: 'custom',
} as const;
